/**
 * @generated SignedSource<<012c50f17c56a9b423ffe1b0f5803341>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StudentsSkillAssessmentsFilterInput = {
  assessmentCompletedFrom?: any | null | undefined;
  assessmentCompletedTo?: any | null | undefined;
  assessmentScores?: ReadonlyArray<number> | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  gradeLevelIds?: ReadonlyArray<string> | null | undefined;
  isActive?: boolean | null | undefined;
  skillCode?: string | null | undefined;
  skillName?: string | null | undefined;
  standardGradeIds?: ReadonlyArray<string> | null | undefined;
  studentName?: string | null | undefined;
  targetGroupIds?: ReadonlyArray<string> | null | undefined;
  userIds?: ReadonlyArray<string> | null | undefined;
};
export type ReportHubSkillAssessmentsTotalQuery$variables = {
  filter: StudentsSkillAssessmentsFilterInput;
};
export type ReportHubSkillAssessmentsTotalQuery$data = {
  readonly studentsSkillAssessments: {
    readonly totalCount: number;
  } | null | undefined;
};
export type ReportHubSkillAssessmentsTotalQuery = {
  response: ReportHubSkillAssessmentsTotalQuery$data;
  variables: ReportHubSkillAssessmentsTotalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      }
    ],
    "concreteType": "StudentSkillAssessmentNodeConnection",
    "kind": "LinkedField",
    "name": "studentsSkillAssessments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportHubSkillAssessmentsTotalQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReportHubSkillAssessmentsTotalQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f3459f3b9dba31c71dd112782ce9474c",
    "id": null,
    "metadata": {},
    "name": "ReportHubSkillAssessmentsTotalQuery",
    "operationKind": "query",
    "text": "query ReportHubSkillAssessmentsTotalQuery(\n  $filter: StudentsSkillAssessmentsFilterInput!\n) {\n  studentsSkillAssessments(filter: $filter) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "b6fe8cbdde08f58d71fa7d6b348d0be0";

export default node;
